<template>

  <v-btn v-if="!disabledRouterLink" icon @click="$emit('actions', [content, selectedEvent])" :color="color" :disabled="checkIsPublished">
    <el-tooltip class="item" effect="dark" :content="content" placement="bottom">
      <v-icon>{{ icon }}</v-icon>
    </el-tooltip>
  </v-btn>
    <v-btn v-else icon :color="(content === 'Editer le post')? '#46A3B9' : 'gray'" :disabled="checkIsPublished" style="opacity: .5">
        <el-tooltip class="item" effect="dark" :content="(content === 'Editer le post')? content : $t('general.calendar.featureForbidden')" placement="bottom">
            <v-icon>{{ icon }}</v-icon>
        </el-tooltip>
    </v-btn>
</template>
<script>
import { $t } from '@/i18n'

export default {
  name: 'ButtonModalCalendar',
  props: ['content', 'color', 'selectedEvent', 'icon', 'disabled'],
  computed: {
    disabledRouterLink () {
      return this.selectedEvent.scheduled.lastExecution !== null
    },
    checkIsPublished () {
      return this.content && this.selectedEvent.name === '✅ ' + $t('general.calendar.postPublished')
    }
  },
}
</script>
